const pathSeq = [] as string[]
let round = true

function num(n: number) {
  return round ? n | 0 : n
}

export function M(x: number, y: number) {
  pathSeq.push(`M ${num(x)} ${num(y)}`)
}

export function L(x: number, y: number) {
  pathSeq.push(`L ${num(x)} ${num(y)}`)
}

export function Z() {
  pathSeq.push('Z')
}
export function Q({
  x,
  y,
  x1,
  y1,
  dx,
  dy,
  dx1,
  dy1
}: {
  x?: number
  y?: number
  x1?: number
  y1?: number
  dx?: number
  dy?: number
  dx1?: number
  dy1?: number
}) {
  if (typeof x === 'number') {
    pathSeq.push(`Q ${num(x1)} ${num(y1)} ${num(x)} ${num(y)}`)
  } else {
    pathSeq.push(`q ${num(dx1)} ${num(dy1)} ${num(dx)} ${num(dy)}`)
  }
}
export function T({
  x,
  y,
  dx,
  dy
}: {
  x?: number
  y?: number
  dx?: number
  dy?: number
}) {
  if (pathSeq.length === 0) {
    throw Error('previous element should be Q/q/T/t')
  } else {
    const last = pathSeq[pathSeq.length - 1].toLowerCase()
    if (!last.startsWith('t') && !last.startsWith('q'))
      throw Error('previous element should be Q/q/T/t')
  }
  if (typeof x === 'number') {
    pathSeq.push(`T ${num(x)} ${num(y)}`)
  } else {
    pathSeq.push(`t ${num(dx)} ${num(dy)}`)
  }
}

export function point(x: number, y: number) {
  pathSeq.push(`${num(x)},${num(y)}`)
}

export function generatePath(cb: () => void): string
export function generatePath(opts: {round: boolean}, cb: () => void): string
export function generatePath(opts, cb?: any) {
  if (!cb) {
    cb = opts
    round = true
  } else {
    round = opts.round
  }
  pathSeq.length = 0
  try {
    cb()
    return pathSeq.join(' ')
  } finally {
    pathSeq.length = 0
  }
}

export function A({
  rx,
  ry,
  xAxisRotation,
  largeArcFlag,
  sweepFlag,
  x,
  y,
  dx,
  dy
}: {
  rx: number
  ry: number
  xAxisRotation: number
  largeArcFlag: number
  sweepFlag: number
  x?: number
  y?: number
  dx?: number
  dy?: number
}) {
  if (typeof x === 'undefined' && typeof dx === 'undefined') {
    throw Error('Either x y or dx dy must be set')
  }
  const isA = typeof x !== 'undefined'
  const lastPart = isA ? `${num(x)} ${num(y)}` : `${num(dx)} ${num(dy)}`
  pathSeq.push(
    `${isA ? 'A' : 'a'} ${num(rx)} ${num(ry)}, ${num(largeArcFlag)}, ${num(
      sweepFlag
    )}, ${lastPart}`
  )
}
